import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { normalizeUserRole, UserRole } from '../enums/user-role.enum';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const currentUser = this.authService.getCurrentUser();
    const requiredRoles = route.data['roles'] as UserRole[];

    if (!currentUser) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const currentRole = normalizeUserRole(
      currentUser.userRoleName || currentUser.userRole || currentUser.userRoleID
    );

    if (requiredRoles && !requiredRoles.includes(currentRole)) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
